<template>
  <div>
    <!-- 外層按鈕：打開簽名板 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <div style="font-size: 16px; font-weight:500;color:#000000">簽名確認</div>
      <el-button v-if="canSign" class="print-notShow" @click="dialogVisible = true" type="primary" round>打開簽名板</el-button>
    </div>

    <!-- 簽名預覽 -->
    <div style="margin-top: 20px;">
      <img v-if="displaySignature" :src="displaySignature" alt="簽名圖片" class="signature-preview" />
      <div v-else class="signature-preview no-signature">尚未簽名</div>
    </div>

    <!-- el-dialog 內放簽名板 -->
    <div class="print-notShow">
      <el-dialog :visible.sync="dialogVisible" width="650px" :modal-append-to-body="false" :show-close="false" center :top="`18px`" @open="loadExistingSignature" @close="onClose">
        <div slot="title" class="signature-dialog-header">
          <button type="button" class="signature-dialog-close" aria-label="close" @click="onClose">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <span>請簽名</span>
        </div>
        <div class="signature-container">
          <div class="signature-wrapper">
            <vue-signature ref="signature" :w="'600px'" :h="'300px'" :backgroundColor="'#fff'" :penColor="'#000'" />
          </div>
        </div>
        <div class="signature-actions" slot="footer">
          <el-button @click="clear" round style="width:100%">清除</el-button>
          <el-button @click="save" round type="primary" style="width:100%">儲存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import vueSignature from 'vue-signature'

export default {
  name: 'SignaturePadDialog',
  components: { vueSignature },
  props: {
    mode: {
      type: String,
      default: 'edit', // 'edit' 編輯模式 , 'view' 檢視模式
    },
    signaturePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      signatureData: null,
    }
  },
  computed: {
    displaySignature() {
      return this.signaturePath || this.signatureData
    },
    canSign() {
      return !this.displaySignature
    },
  },
  methods: {
    clear() {
      this.$refs.signature.clear()
    },
    loadExistingSignature() {
      this.$nextTick(() => {
        if (!this.$refs.signature) return
        this.$refs.signature.clear()
      })
    },
    onClose() {
      if (this.$refs.signature) {
        this.$refs.signature.clear()
      }
      this.dialogVisible = false
    },
    async save() {
      this.signatureData = this.$refs.signature.save()
      await this.onSaveFile()
      this.dialogVisible = false
    },

    base64ToBlob(base64) {
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    async onSaveFile() {
      try {
        if (!this.signatureData || this.signatureData === 'data:,') {
          console.error('簽名內容為空')
          this.$message.error('簽名內容為空，請重新簽名')
          return
        }
        const blob = this.base64ToBlob(this.signatureData)
        const rid = Math.floor(Math.random() * 5000000)
        const file = new File([blob], `signature_${rid}.png`, { type: blob.type })

        const formData = new FormData()
        formData.append('files[]', file)
        formData.append('dir', 'signature')

        const res = await this.$store.dispatch('merchant/uploadMerchantMedia', formData)
        this.$emit('signatureSaved', res)
      } catch (error) {
        console.error('上傳簽名失敗:', error)
        this.$message.error('上傳簽名失敗，請稍後再試')
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog--center .el-dialog__body {
  padding: 0px;
}

.signature-dialog-header {
  position: relative;
  text-align: center;
}

.signature-dialog-close {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 8px;
  font-size: 22px;
  line-height: 1;
  color: #909399;

  &:hover {
    color: $color-primary;
  }
}

.signature-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-wrapper {
  border: solid 2px #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 18px;
  padding: 8px;
  display: inline-block;
}

.signature-actions {
  margin-top: 12px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.signature-preview {
  width: 100%;
  height: 180px;
  object-fit: contain;
  border: solid 2px #e5e7eb;
  border-radius: 8px;
}

.no-signature {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  font-size: 18px;
  color: #999;
}
</style>
